/**
 *  @TODO: Split to actions and mutations
 */

// Module ProductListPage
export const FETCH_FILTER_MODEL = 'fetchFilterModel';
export const FETCH_MORE_FILTERS = 'fetchMoreFilters';
export const FETCH_CURRENT_MODEL = 'fetchCurrentModel';
export const FETCH_DETAILS_MODEL = 'fetchDetailsModel';
export const FETCH_PRODUCTS_SECTIONS = 'fetchProductsSections';
export const FETCH_LIKES_MODEL = 'fetchLikesModel';
export const FETCH_MORE_PRODUCTS = 'fetchMoreProducts';
export const GET_LIGHTBOX_DATA = 'getLightboxData';
export const SET_PRODUCT_DETAILS_CURRENT_ID = 'setProductDetailsCurrentId';
export const SET_EXPANDED_COUPON_ID = 'setExpandedCouponId';
export const PRODUCT_DETAILS_SHOW = 'productDetailsShow';
export const PRODUCT_DETAILS_HIDE = 'productDetailsHide';
export const PRODUCT_CLICK = 'productClick';
export const COUPON_CLICK = 'couponClick';
export const SET_CURRENT_MODEL = 'setCurrentModel';
export const SET_DETAILS_MODEL = 'setDetailsModel';
export const SET_CURRENT_URL = 'setCurrentUrl';
export const SET_CURRENT_MODEL_PARAMS = 'setCurrentModelParams';
export const ADD_PRODUCTS_TO_CURRENT_MODEL = 'addProductsToCurrentModel';
export const SET_FILTER_MODEL = 'setFilterModel';
export const SET_FILTER_URL = 'setFilterUrl';
export const SET_SERIALIZED_PRICE_URL = 'setSerializedPriceUrl';
export const SET_FILTER_LIST_VISIBILITY = 'setFilterListVisibility';
export const SET_FILTER_LIST_LOADING = 'setFilterListLoading';
export const SET_PRODUCT_LIST_LOADING = 'setProductListLoading';
export const UPDATE_FILTER = 'updateFilter';
export const FILTER_LIST_SHOW = 'filterListShow';
export const FILTER_LIST_HIDE = 'filterListHide';
// Module MENU
export const SET_MENU_VISIBILITY = 'setMenuVisibility';
export const SET_MENU_REDIRECTING = 'setMenuRedirecting';
export const MENU_SHOW = 'menuShow';
export const MENU_HIDE = 'menuHide';
export const SET_MENU_LIST_LOADING = 'setMenuListLoading';
export const GET_MENU_DATA = 'getMenuData';
export const FETCH_MENU_DATA = 'fetchMenuData';
export const FETCH_MEGA_MENU_DATA = 'fetchMegaMenuData';
export const SET_MEGA_MENU_LOADING = 'setMegaMenuLoading';
export const SET_MEGA_MENU_MODEL = 'setMegaMenuModel';
export const SET_MENU_MODEL = 'setMenuModel';
// Module USER
export const USER_FETCH_DATA = 'userFetchData';
export const USER_SET_DATA = 'userSetData';
